import { render, staticRenderFns } from "./PurchaseOptionHeader.vue?vue&type=template&id=7884cbae&scoped=true&"
import script from "./PurchaseOptionHeader.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOptionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOptionHeader.vue?vue&type=style&index=0&id=7884cbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884cbae",
  null
  
)

export default component.exports